const AdministrationAreas = [
  {
    id: 1,
    name: 'Districts',
    url: 'https://tiff-library.s3.eu-west-2.amazonaws.com/malaysia/administration/districts.zip',
    onEachFeature: ((feature, layer) => {
      layer.bindTooltip(`${feature.properties['NAME_2']}`, {closeButton: false});
    })
  },
  {
    id: 2,
    name: 'States',
    url: 'https://tiff-library.s3.eu-west-2.amazonaws.com/malaysia/administration/states.zip',
    onEachFeature: ((feature, layer) => {
      layer.bindTooltip(feature.properties['NAME_1'].toString(), {closeButton: false});
    })
  }
]

export default {
  sectionText: "Background",
  section: "background",
  components: [
    {
      text: "OpenSteet Map",
      type: "switch",
      stateProperty: "openStreetMapLayerIsShowing",
      initialState: true
    },
    {
      text: "Administration Areas",
      type: "multi-select",
      stateProperty: "administrationAreas",
      initialState: [],
      layerType: 'multi-shapefile',
      shapefiles: AdministrationAreas,
      options: AdministrationAreas.map(area => ({
        key: area.name,
        text: area.name,
        value: area.name
      }))
    }
  ],
}